var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 603.9 401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#6c63ff;}.cls-3{fill:#f55f44;}.cls-4{fill:#fda57d;}.cls-5{opacity:0.05;}.cls-11,.cls-17,.cls-5,.cls-9{isolation:isolate;}.cls-6{opacity:0.7;}.cls-7{fill:url(#linear-gradient-2);}.cls-25,.cls-8{fill:#4db6ac;}.cls-26,.cls-9{fill:none;stroke-miterlimit:10;}.cls-9{stroke:#535461;opacity:0.6;}.cls-10{fill:url(#linear-gradient-3);}.cls-11,.cls-17{opacity:0.1;}.cls-12{fill:#e0e0e0;}.cls-13{fill:url(#linear-gradient-4);}.cls-14,.cls-17{fill:#535461;}.cls-15,.cls-19{fill:#fff;}.cls-16{fill:#eee;}.cls-18{fill:#bdccd4;}.cls-18,.cls-19,.cls-23,.cls-25,.cls-26{stroke:#25aae1;}.cls-18,.cls-19,.cls-23,.cls-25{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-20{fill:#8ae9ff;}.cls-21,.cls-23{fill:#4ecdf4;}.cls-22{fill:#25aae1;}.cls-24{fill:#0097c6;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 393.8,
    y1: 15359.26,
    x2: 393.8,
    y2: 15619.43,
    gradientTransform: "matrix(1, 0, 0, -1, -168.58, 15699)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 198.22,
    y1: 15366.11,
    x2: 254.46,
    y2: 15366.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 569.26,
    y1: 15317.64,
    x2: 569.26,
    y2: 15360.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 224.95,
    y1: 15482.49,
    x2: 224.95,
    y2: 15592.67,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 15862)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1Asset 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.42,277.27c-4.67-16.94-30.59-29.43-50.81-32.66v-8.14l1.11-.43a18,18,0,0,0-1-4.77,49.08,49.08,0,0,0,21.51-17A55.3,55.3,0,0,0,255.35,129a10.85,10.85,0,0,0-4.88-20,21.18,21.18,0,0,0-33-24.61,21.17,21.17,0,0,1,31.12,18.7v.55a21.18,21.18,0,1,0-41,7.92,10.59,10.59,0,0,0-7,15.55,55.3,55.3,0,0,0-13.52,87.93A49.09,49.09,0,0,0,207,230.87v13.57c-20.44,2.92-47.35,15.64-52,33-4.1,15.13-8.47,31.74-10.65,41.5C163,332,202.1,339.74,226.63,339.74c23.31,0,61.41-7,79.51-18.89C304.21,310.14,299.7,292.79,295.42,277.27Zm-37.37-156.5v.57a10.59,10.59,0,0,0-8.79-9.83q.31-.52.59-1.06A10.59,10.59,0,0,1,258.06,120.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.62,336c22.65,0,59.66-6.75,77.25-18.35-1.9-10.41-6.27-27.26-10.45-42.34-5.29-19.21-38.68-32.52-58.61-32.52H215.62c-20,0-53.42,13.39-58.65,32.68-4,14.7-8.25,30.84-10.34,40.32C164.75,328.53,202.79,336,226.62,336Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 226.26,
    cy: 177.02,
    r: 53.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M211.76,214.37h28.1a4.18,4.18,0,0,1,4.18,4.18v28.74a17.27,17.27,0,0,1-17.27,17.27h-2a17.27,17.27,0,0,1-17.27-17.27V218.57a4.18,4.18,0,0,1,4.18-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M227.47,238.7a47.39,47.39,0,0,0,17.66-3.4,17.5,17.5,0,0,0-17.42-16.36h-1.5a17.51,17.51,0,0,0-17.42,15.93A47.39,47.39,0,0,0,227.47,238.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 226.36,
    cy: 186.6,
    r: 47.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 210.26,
    cy: 124.44,
    r: 10.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 246.83,
    cy: 124.44,
    r: 10.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 227.4,
    cy: 107.3,
    r: 20.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M249.12,111.87a10.24,10.24,0,0,0-5.74,1.75,10.29,10.29,0,0,1,9.18,18.22,10.28,10.28,0,0,0-3.48-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M230.83,83.29A20.49,20.49,0,0,0,217.71,88a20.57,20.57,0,0,1,22.74,34,20.57,20.57,0,0,0-9.66-38.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M192,143.86s5.71,37.72,77.73,17.14l-35.44-30.86Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M85.55,319.08a10.92,10.92,0,0,0-4.33-11.58,32.26,32.26,0,0,1-2.9-1.87,10.54,10.54,0,0,1-2.91-4.88c-1.46-4.36-1.91-9.26-4.46-13.21-2.32-3.59-6.84-4.64-10.84-5a8.61,8.61,0,0,0-4.33.4c-2.23,1-3.3,3.64-3.4,6.1s.54,4.88.7,7.31-.28,5.14-2.09,6.79-4.39,1.85-6.78,2.19A44.9,44.9,0,0,0,35,307.62c-2.49.91-5.28,2.55-5.39,5.21-.1,2.17,1.65,3.9,3,5.62a14.39,14.39,0,0,1,2.85,11.47c-.85,4-3.69,7.51-4.18,11.6a5,5,0,0,0,.37,3,5.57,5.57,0,0,0,1.55,1.64c1.54,1.19,3.26,2.15,4.72,3.44,3,2.7,4.69,6.61,6,10.45.13.37.23.75.35,1.12h-3a11.09,11.09,0,0,0-11.07,11.07h0a11.09,11.09,0,0,0,11.07,11.07H71.11a11.09,11.09,0,0,0,11.07-11.07h0a11.09,11.09,0,0,0-11-11H62.95c1.94-2.59,4-5,7-6s6.61-.41,8.95-2.49a7,7,0,0,0,2-4,12,12,0,0,0-1.31-8c-.94-1.68-2.32-3.21-2.62-5.11A7.57,7.57,0,0,1,78.09,331C80.33,326.8,84.33,323.61,85.55,319.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M60,285a8.19,8.19,0,0,0-4.12.38c-2.13,1-3.14,3.48-3.23,5.8s.51,4.63.7,7-.26,4.88-2,6.47-4.18,1.76-6.46,2.09a42.75,42.75,0,0,0-8.75,2.17c-2.38.86-5,2.43-5.14,5-.09,2.09,1.57,3.71,2.83,5.36a13.71,13.71,0,0,1,2.72,10.91c-.81,3.85-3.48,7.15-4,11.05A4.79,4.79,0,0,0,33,344a5.34,5.34,0,0,0,1.48,1.57c1.47,1.14,3.11,2,4.49,3.28,2.9,2.56,4.47,6.27,5.68,10a80.75,80.75,0,0,1,2.79,11.06c2.49-1.6,5.72-1.58,8.36-2.89,5.67-2.79,7.58-10.84,13.57-12.84,2.84-.95,6.27-.39,8.52-2.38A6.68,6.68,0,0,0,79.78,348a11.42,11.42,0,0,0-1.26-7.59c-.9-1.6-2.21-3.05-2.49-4.88A7.21,7.21,0,0,1,77.1,331c2.15-3.92,6-7,7.12-11.27a10.4,10.4,0,0,0-4.13-11,30.73,30.73,0,0,1-2.79-1.78,10,10,0,0,1-2.79-4.64c-1.39-4.18-1.82-8.82-4.25-12.54C68.12,286.29,63.82,285.32,60,285Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M60,285.09s5.27,70.61-8.43,82.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 31.52,
    y: 359.89,
    width: 49.51,
    height: 21.07,
    rx: 9.97,
    ry: 9.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M31,312.5s13.47-1.57,29.91,8.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M60.64,329.34a34.79,34.79,0,0,1,23.55-14.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.31,341.2S51,338,59.55,343.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M58.49,350.54a31.2,31.2,0,0,1,20.77-.83"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M414.72,346.44v-7.6h-38V374a7.4,7.4,0,0,0,7.4,7.4h23.16a7.4,7.4,0,0,0,7.4-7.4v-7.8a9.87,9.87,0,0,0,0-19.74Zm0,15.94V350.23a6.08,6.08,0,1,1,.41,12.15h-.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M413.53,347.62a9,9,0,1,0,9,9h0A9,9,0,0,0,413.53,347.62Zm0,14.56a5.57,5.57,0,1,1,5.57-5.57,5.57,5.57,0,0,1-5.57,5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M413.53,347.62a9,9,0,1,0,9,9h0A9,9,0,0,0,413.53,347.62Zm0,14.56a5.57,5.57,0,1,1,5.57-5.57,5.57,5.57,0,0,1-5.57,5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.84,340.69h34.66v32.06a6.79,6.79,0,0,1-6.79,6.79H385.64a6.79,6.79,0,0,1-6.79-6.79h0V340.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    y: 379.51,
    width: 449.9,
    height: 15.25
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 129.28,
    y: 269.33,
    width: 191.33,
    height: 110.17,
    rx: 10.1,
    ry: 10.1
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 132.75,
    y: 271.37,
    width: 184.4,
    height: 108.14,
    rx: 18.7,
    ry: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 224.95,
    cy: 325.44,
    r: 6.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 19.07,
    y: 394.76,
    width: 411.77,
    height: 6.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 19.07,
    y: 394.76,
    width: 411.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M407.26,340.69v32.06a6.76,6.76,0,0,1-6.76,6.76H404a6.76,6.76,0,0,0,6.76-6.76h0V340.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M385.66,314.85a2,2,0,0,0-1.53.78c-.45.82.37,1.76,1.12,2.32a15.19,15.19,0,0,1,3.8,3.53,4.39,4.39,0,0,1,.21,4.88c-1.34,1.83-4.56,2.22-4.88,4.47-.2,1.44,1,2.68,2.31,3.4,3.12,1.79,7.15,2.26,9.41,5.07a7.18,7.18,0,0,1,5.12-3.48c2.08-.45,4.25-.44,6.37-.76a2.2,2.2,0,0,0,1.77-.95c.59-1.2-1.09-2.64-.51-3.84.45-.92,1.74-.84,2.69-1.21a3.5,3.5,0,0,0,1.74-4.18,7.91,7.91,0,0,0-3-3.87c-3.48-2.79-7.74-4.38-12-5.57a30.83,30.83,0,0,0-6.38-1.48A31.39,31.39,0,0,0,385.66,314.85Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 327.09,
    cy: 256.1,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 342.9,
    cy: 228.74,
    r: 8.51
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-18",
    d: "M588.6,171H312.82a19,19,0,0,1-13.87-6l-.43-.46v-7.95H602.9v7.95l-.43.46A19,19,0,0,1,588.6,171Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Path_2",
    "data-name": "<Path>",
    className: "cls-19",
    x: 298.52,
    y: 156.55,
    width: 304.38,
    height: 7.95
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_3",
    "data-name": "<Path>",
    className: "cls-19",
    d: "M450.71,160.88h24.21a13.86,13.86,0,0,0,7.79-2.21l3-2.12H415.67l3,2.12a13.86,13.86,0,0,0,7.79,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Rectangle_",
    "data-name": "<Rectangle>",
    className: "cls-18",
    d: "M325.76,1h249.9a4.09,4.09,0,0,1,4.09,4.09V156.55a0,0,0,0,1,0,0H321.67a0,0,0,0,1,0,0V5.09A4.09,4.09,0,0,1,325.76,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_2",
    "data-name": "<Rectangle>",
    className: "cls-19",
    x: 331.1,
    y: 10.53,
    width: 239.22,
    height: 136.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_3",
    "data-name": "<Rectangle>",
    className: "cls-2",
    x: 348.26,
    y: 55.26,
    width: 40.67,
    height: 40.66
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_4",
    "data-name": "<Rectangle>",
    className: "cls-2",
    x: 348.26,
    y: 101.08,
    width: 40.67,
    height: 40.66
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_5",
    "data-name": "<Rectangle>",
    className: "cls-20",
    x: 392.05,
    y: 55.26,
    width: 47.8,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_6",
    "data-name": "<Rectangle>",
    className: "cls-20",
    x: 392.05,
    y: 61.95,
    width: 40.93,
    height: 2.35
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_7",
    "data-name": "<Rectangle>",
    className: "cls-21",
    x: 392.05,
    y: 76.77,
    width: 53.59,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_8",
    "data-name": "<Rectangle>",
    className: "cls-21",
    x: 447.37,
    y: 76.77,
    width: 23.59,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_9",
    "data-name": "<Rectangle>",
    className: "cls-21",
    x: 472.69,
    y: 76.77,
    width: 45.3,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_10",
    "data-name": "<Rectangle>",
    className: "cls-21",
    x: 392.05,
    y: 81.36,
    width: 53.59,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_11",
    "data-name": "<Rectangle>",
    className: "cls-21",
    x: 447.37,
    y: 81.36,
    width: 44.93,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_12",
    "data-name": "<Rectangle>",
    className: "cls-21",
    x: 392.05,
    y: 85.82,
    width: 44.93,
    height: 2.35
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_4",
    "data-name": "<Path>",
    className: "cls-22",
    d: "M395.87,65.68l.61,1.23a.54.54,0,0,0,.41.3l1.36.2a.54.54,0,0,1,.3.93l-1,1a.54.54,0,0,0-.16.48l.23,1.35a.54.54,0,0,1-.79.57l-1.22-.64a.54.54,0,0,0-.51,0l-1.22.64a.54.54,0,0,1-.79-.57l.23-1.35a.54.54,0,0,0-.16-.48l-1-1a.54.54,0,0,1,.3-.93l1.36-.2a.54.54,0,0,0,.41-.3l.61-1.23A.54.54,0,0,1,395.87,65.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_5",
    "data-name": "<Path>",
    className: "cls-22",
    d: "M404.44,65.68l.61,1.23a.54.54,0,0,0,.41.3l1.36.2a.54.54,0,0,1,.3.93l-1,1a.54.54,0,0,0-.16.48l.23,1.35a.54.54,0,0,1-.79.57l-1.22-.64a.54.54,0,0,0-.51,0l-1.22.64a.54.54,0,0,1-.79-.57l.23-1.35a.54.54,0,0,0-.16-.48l-1-1a.54.54,0,0,1,.3-.93l1.36-.2a.54.54,0,0,0,.41-.3l.61-1.23A.54.54,0,0,1,404.44,65.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_6",
    "data-name": "<Path>",
    className: "cls-22",
    d: "M413,65.68l.61,1.23a.54.54,0,0,0,.41.3l1.36.2a.54.54,0,0,1,.3.93l-1,1a.54.54,0,0,0-.16.48l.23,1.35a.54.54,0,0,1-.79.57l-1.22-.64a.54.54,0,0,0-.51,0L411,71.7a.54.54,0,0,1-.79-.57l.23-1.35a.54.54,0,0,0-.16-.48l-1-1a.54.54,0,0,1,.3-.93l1.36-.2a.54.54,0,0,0,.41-.3l.61-1.23A.54.54,0,0,1,413,65.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_7",
    "data-name": "<Path>",
    className: "cls-22",
    d: "M421.57,65.68l.61,1.23a.54.54,0,0,0,.41.3l1.36.2a.54.54,0,0,1,.3.93l-1,1a.54.54,0,0,0-.16.48l.23,1.35a.54.54,0,0,1-.79.57l-1.22-.64a.54.54,0,0,0-.51,0l-1.22.64a.54.54,0,0,1-.79-.57l.23-1.35a.54.54,0,0,0-.16-.48l-1-1a.54.54,0,0,1,.3-.93l1.36-.2a.54.54,0,0,0,.41-.3l.61-1.23A.54.54,0,0,1,421.57,65.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_8",
    "data-name": "<Path>",
    className: "cls-22",
    d: "M430.14,65.68l.61,1.23a.54.54,0,0,0,.41.3l1.36.2a.54.54,0,0,1,.3.93l-1,1a.54.54,0,0,0-.16.48l.23,1.35a.54.54,0,0,1-.79.57l-1.22-.64a.54.54,0,0,0-.51,0l-1.22.64a.54.54,0,0,1-.79-.57l.23-1.35a.54.54,0,0,0-.16-.48l-1-1a.54.54,0,0,1,.3-.93l1.36-.2a.54.54,0,0,0,.41-.3l.61-1.23A.54.54,0,0,1,430.14,65.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_13",
    "data-name": "<Rectangle>",
    className: "cls-20",
    x: 392.05,
    y: 101.08,
    width: 47.8,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_14",
    "data-name": "<Rectangle>",
    className: "cls-20",
    x: 392.05,
    y: 107.77,
    width: 40.93,
    height: 2.35
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_15",
    "data-name": "<Rectangle>",
    className: "cls-21",
    x: 392.05,
    y: 122.59,
    width: 53.59,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_16",
    "data-name": "<Rectangle>",
    className: "cls-21",
    x: 447.37,
    y: 122.59,
    width: 23.59,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_17",
    "data-name": "<Rectangle>",
    className: "cls-21",
    x: 472.69,
    y: 122.59,
    width: 45.3,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_18",
    "data-name": "<Rectangle>",
    className: "cls-21",
    x: 392.05,
    y: 127.18,
    width: 53.59,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_19",
    "data-name": "<Rectangle>",
    className: "cls-21",
    x: 447.37,
    y: 127.18,
    width: 44.93,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_20",
    "data-name": "<Rectangle>",
    className: "cls-21",
    x: 392.05,
    y: 131.64,
    width: 44.93,
    height: 2.35
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_9",
    "data-name": "<Path>",
    className: "cls-22",
    d: "M395.87,111.5l.61,1.23a.54.54,0,0,0,.41.3l1.36.2a.54.54,0,0,1,.3.93l-1,1a.54.54,0,0,0-.16.48l.23,1.35a.54.54,0,0,1-.79.57l-1.22-.64a.54.54,0,0,0-.51,0l-1.22.64a.54.54,0,0,1-.79-.57l.23-1.35a.54.54,0,0,0-.16-.48l-1-1a.54.54,0,0,1,.3-.93l1.36-.2a.54.54,0,0,0,.41-.3l.61-1.23A.54.54,0,0,1,395.87,111.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_10",
    "data-name": "<Path>",
    className: "cls-22",
    d: "M404.44,111.5l.61,1.23a.54.54,0,0,0,.41.3l1.36.2a.54.54,0,0,1,.3.93l-1,1a.54.54,0,0,0-.16.48l.23,1.35a.54.54,0,0,1-.79.57l-1.22-.64a.54.54,0,0,0-.51,0l-1.22.64a.54.54,0,0,1-.79-.57l.23-1.35a.54.54,0,0,0-.16-.48l-1-1a.54.54,0,0,1,.3-.93l1.36-.2a.54.54,0,0,0,.41-.3l.61-1.23A.54.54,0,0,1,404.44,111.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_11",
    "data-name": "<Path>",
    className: "cls-22",
    d: "M413,111.5l.61,1.23a.54.54,0,0,0,.41.3l1.36.2a.54.54,0,0,1,.3.93l-1,1a.54.54,0,0,0-.16.48l.23,1.35a.54.54,0,0,1-.79.57l-1.22-.64a.54.54,0,0,0-.51,0l-1.22.64a.54.54,0,0,1-.79-.57l.23-1.35a.54.54,0,0,0-.16-.48l-1-1a.54.54,0,0,1,.3-.93L411,113a.54.54,0,0,0,.41-.3l.61-1.23A.54.54,0,0,1,413,111.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_12",
    "data-name": "<Path>",
    className: "cls-22",
    d: "M421.57,111.5l.61,1.23a.54.54,0,0,0,.41.3l1.36.2a.54.54,0,0,1,.3.93l-1,1a.54.54,0,0,0-.16.48l.23,1.35a.54.54,0,0,1-.79.57l-1.22-.64a.54.54,0,0,0-.51,0l-1.22.64a.54.54,0,0,1-.79-.57l.23-1.35a.54.54,0,0,0-.16-.48l-1-1a.54.54,0,0,1,.3-.93l1.36-.2a.54.54,0,0,0,.41-.3l.61-1.23A.54.54,0,0,1,421.57,111.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_13",
    "data-name": "<Path>",
    className: "cls-21",
    d: "M430.14,111.5l.61,1.23a.54.54,0,0,0,.41.3l1.36.2a.54.54,0,0,1,.3.93l-1,1a.54.54,0,0,0-.16.48l.23,1.35a.54.54,0,0,1-.79.57l-1.22-.64a.54.54,0,0,0-.51,0l-1.22.64a.54.54,0,0,1-.79-.57l.23-1.35a.54.54,0,0,0-.16-.48l-1-1a.54.54,0,0,1,.3-.93l1.36-.2a.54.54,0,0,0,.41-.3l.61-1.23A.54.54,0,0,1,430.14,111.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_21",
    "data-name": "<Rectangle>",
    className: "cls-23",
    x: 564.14,
    y: 10.53,
    width: 6.18,
    height: 136.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_22",
    "data-name": "<Rectangle>",
    className: "cls-20",
    x: 565.6,
    y: 72.9,
    width: 3.25,
    height: 41.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_23",
    "data-name": "<Rectangle>",
    className: "cls-24",
    x: 565.56,
    y: 142.3,
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_14",
    "data-name": "<Path>",
    className: "cls-15",
    points: "567.21 145.01 568.61 142.89 567.21 142.89 565.8 142.89 567.21 145.01"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_5",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_6",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_15",
    "data-name": "<Path>",
    className: "cls-25",
    d: "M321.67,30V39.4a11.73,11.73,0,0,0,23.46,0V30Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_16",
    "data-name": "<Path>",
    className: "cls-19",
    d: "M345.13,30V39.4a11.73,11.73,0,0,0,23.46,0V30Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_17",
    "data-name": "<Path>",
    className: "cls-25",
    d: "M368.59,30V39.4a11.73,11.73,0,0,0,23.46,0V30Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_18",
    "data-name": "<Path>",
    className: "cls-19",
    d: "M392.05,30V39.4a11.73,11.73,0,0,0,23.46,0V30Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_19",
    "data-name": "<Path>",
    className: "cls-25",
    d: "M415.51,30V39.4a11.73,11.73,0,0,0,23.46,0V30Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_20",
    "data-name": "<Path>",
    className: "cls-19",
    d: "M439,30V39.4a11.73,11.73,0,0,0,23.46,0V30Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_21",
    "data-name": "<Path>",
    className: "cls-25",
    d: "M462.44,30V39.4a11.73,11.73,0,0,0,23.46,0V30Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_22",
    "data-name": "<Path>",
    className: "cls-19",
    d: "M485.9,30V39.4a11.73,11.73,0,0,0,23.46,0V30Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_23",
    "data-name": "<Path>",
    className: "cls-25",
    d: "M509.36,30V39.4a11.73,11.73,0,0,0,23.46,0V30Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_24",
    "data-name": "<Path>",
    className: "cls-19",
    d: "M532.82,30V39.4a11.73,11.73,0,0,0,23.46,0V30Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_25",
    "data-name": "<Path>",
    className: "cls-25",
    d: "M556.28,30V39.4a11.73,11.73,0,0,0,23.46,0V30Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_7",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_26",
    "data-name": "<Path>",
    className: "cls-25",
    points: "352.53 10.53 330.75 10.53 321.67 30.04 345.13 30.04 352.53 10.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_27",
    "data-name": "<Path>",
    className: "cls-19",
    points: "374.31 10.53 352.53 10.53 345.13 30.04 368.59 30.04 374.31 10.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_28",
    "data-name": "<Path>",
    className: "cls-25",
    points: "396.09 10.53 374.31 10.53 368.59 30.04 392.05 30.04 396.09 10.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_29",
    "data-name": "<Path>",
    className: "cls-19",
    points: "417.87 10.53 396.09 10.53 392.05 30.04 415.51 30.04 417.87 10.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_30",
    "data-name": "<Path>",
    className: "cls-25",
    points: "439.64 10.53 417.87 10.53 415.51 30.04 438.98 30.04 439.64 10.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_31",
    "data-name": "<Path>",
    className: "cls-19",
    points: "461.42 10.53 439.64 10.53 438.98 30.04 462.44 30.04 461.42 10.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_32",
    "data-name": "<Path>",
    className: "cls-25",
    points: "483.2 10.53 461.42 10.53 462.44 30.04 485.9 30.04 483.2 10.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_33",
    "data-name": "<Path>",
    className: "cls-19",
    points: "504.98 10.53 483.2 10.53 485.9 30.04 509.36 30.04 504.98 10.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_34",
    "data-name": "<Path>",
    className: "cls-25",
    points: "526.76 10.53 504.98 10.53 509.36 30.04 532.82 30.04 526.76 10.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_35",
    "data-name": "<Path>",
    className: "cls-19",
    points: "548.54 10.53 526.76 10.53 532.82 30.04 556.28 30.04 548.54 10.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_36",
    "data-name": "<Path>",
    className: "cls-25",
    points: "570.32 10.53 548.54 10.53 556.28 30.04 579.75 30.04 570.32 10.53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_8",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_37",
    "data-name": "<Path>",
    className: "cls-15",
    points: "385.49 90.95 378.32 83.79 383.74 81.3 368.61 77.14 372.77 92.27 375.26 86.86 382.42 94.02 385.49 90.95"
  }), /*#__PURE__*/React.createElement("line", {
    id: "_Path_38",
    "data-name": "<Path>",
    className: "cls-26",
    x1: 361.66,
    y1: 70.19,
    x2: 367.28,
    y2: 75.82
  }), /*#__PURE__*/React.createElement("line", {
    id: "_Path_39",
    "data-name": "<Path>",
    className: "cls-26",
    x1: 359.03,
    y1: 80.19,
    x2: 366.93,
    y2: 81.18
  }), /*#__PURE__*/React.createElement("line", {
    id: "_Path_40",
    "data-name": "<Path>",
    className: "cls-26",
    x1: 371.66,
    y1: 67.56,
    x2: 372.64,
    y2: 75.46
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/Marketplace.63fc39aca941441214d5a2961f20cdb0.svg";
export { ForwardRef as ReactComponent };